import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Data {
  id: number;
  name: string;
  mobile: number;
  gender: string;
  address: string;
}

interface DataState {
  data: Data[];
}

const initialState: DataState = {
  data: [],
};

const dataSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    addData: (state, action: PayloadAction<Data>) => {
      state.data.push(action.payload);
    },
  },
});

export const { addData } = dataSlice.actions;
export default dataSlice.reducer;
